import formName from 'constants/formName'
import { ChangePasswordFormType, PasswordStrengthType, StateType } from 'data/types'
import { getFormValues as reduxGetFormValues } from 'redux-form'
import { createSelector } from 'reselect'

const initialValues: ChangePasswordFormType = {
  fieldLoading: '',
  passwordStrength: 0
}

// FIXME "as ChangePasswordFormType" should  not be needed as type should be infered, find out what's missing
const getFormValues = (state: StateType): ChangePasswordFormType =>
  reduxGetFormValues(formName.CHANGE_PASSWORD)(state) as ChangePasswordFormType

const getValues: (state: StateType) => ChangePasswordFormType = createSelector(
  getFormValues,
  (values: void | ChangePasswordFormType) => values || initialValues
)

const getFieldLoading = createSelector(getValues, (form) => form.fieldLoading)

const getPasswordStrength: (state: StateType) => PasswordStrengthType = createSelector(
  getValues,
  (form) => form.passwordStrength
)

export default {
  getFieldLoading,
  getPasswordStrength,
  getValues,
  initialValues
}
